<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item in tabOptions"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <component
          v-if="activeName === item.name"
          :is="item.component"
          @swicthTab="swicthTab"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import transfer from './components/transfer.vue';
import records from './components/records.vue';
import { sstore } from '@/libs/utils/util';
export default {
  name: 'ExternalContactsTransfer',
  components: {
    transfer,
    records,
  },
  data() {
    return {
      activeName: 'transfer',
      tabOptions: [
        {
          name: 'transfer',
          label: '批量转移',
          component: transfer,
        },
        {
          name: 'records',
          label: '明细查询',
          component: records,
        },
      ],
      breadcrumb: [
        {
          menu_name: '企业微信管理',
        },
        {
          menu_name: '外部联系人转移',
        },
        {
          menu_name: '批量转移',
        },
      ],
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    }
    this.breadcrumbChange();
  },
  methods: {
    handleTabClick(tab) {
      const { name } = tab;
      this.activeName = name;
      this.breadcrumbChange();
    },
    breadcrumbChange() {
      this.breadcrumb[2] = {
        menu_name: this.tabOptions.find((tab) => tab.name === this.activeName).label,
      };
      this.breadcrumb.reverse().reverse();
      this.g_breadcrumb(this.breadcrumb);
    },
    swicthTab(params) {
      const { id } = params;
      this.activeName = 'records';
      sstore.setItem('record_id', id);
      this.breadcrumbChange();
    },
  },
};
</script>
